'use strict'
exports.opening = require('./opening')
exports.closing = require('./closing')
